define('views/leftnav/Podio.Views.LeftNav.OrgNavOrg',['require','translate','underscore','jquery','jquery.scrollTo','lib/backbone/Backbone.PodioView','react','react-dom','component!DeleteInactiveOrganizationModalComponent','component!Pricing/PricingPaywallComponent','lib/Podio.Utils','lib/Podio.Config','lib/Podio.Routes','lib/Podio.Transport','lib/Podio.UI.FlashMessage','lib/Podio.UI.ActionDropdown','lib/Podio.UI.Space.ShareSpaceModal','lib/Podio.Organizations.Setup','lib/Podio.UI.Modal','lib/GlobalEventBus','moment','models/Podio.Models.User','views/lib/Podio.Views.SimpleBalloon','jst!leftnav/_org_nav_organization','jst!leftnav/_org_nav_grants','jst!leftnav/_org_nav_space','lib/Podio.Utils','controllers/conversations/Podio.Controllers.Conversations.New'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('jquery.scrollTo');

  var PodioView = require('lib/backbone/Backbone.PodioView');

  var React = require('react');
  var ReactDOM = require('react-dom');
  var DeleteInactiveOrganizationModalComponent = React.createFactory(require('component!DeleteInactiveOrganizationModalComponent'));
  var PricingPaywallComponent = React.createFactory(require('component!Pricing/PricingPaywallComponent'));

  var utils = require('lib/Podio.Utils');
  var config = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');
  var transport = require('lib/Podio.Transport');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var actionDropdown = require('lib/Podio.UI.ActionDropdown');
  var shareSpaceModal = require('lib/Podio.UI.Space.ShareSpaceModal');
  var organizationsSetup = require('lib/Podio.Organizations.Setup');
  var modal = require('lib/Podio.UI.Modal');
  var globalEvent = require('lib/GlobalEventBus');

  var moment = require('moment');

  var User = require('models/Podio.Models.User');
  var user = new User();

  var SimpleBalloon = require('views/lib/Podio.Views.SimpleBalloon');

  var jstOrgNavOrganization = require('jst!leftnav/_org_nav_organization');
  var jstOrgNavGrants = require('jst!leftnav/_org_nav_grants');
  var jstOrgNavSpace = require('jst!leftnav/_org_nav_space');

  var podioUtils = require('lib/Podio.Utils');

  return PodioView.extend({

    tagName : 'li',
    podioEvents: {
      'click .space-more-link a'    : 'onExpandSpacesClicked',
      'click .space-less-link a'    : 'onCollapseSpacesClicked',
      'click default .header'       : 'onToggleClicked',
      'click a.leave-organization'  : 'onLeaveOrganizationClicked',
      'click a.request-admin-access': 'onRequestAdminAccessClicked',
      'click .inactive-org .edit-org' : 'onEditOrganizationClicked',
      'click .inactive-org .img'    : 'onEditOrganizationClicked',
      'click .delete-inactive-org'  : 'onDeleteInactiveOrgClicked',
      'action-dropdown.opened'      : 'onActionDropdownOpened',
      'action-dropdown.closed'      : 'onActionDropdownClosed',
      'click default .paywall': 'onPotentialPaywallClick',
      'click default .invoke-create-space-modal': 'onCreateSpaceClick',
      'click a.cancel-trial-organization': 'onCancelTrialOrgClick'
    },

    initialize: function() {
      _.bindAll(this, 'bindEvents', 'onExpandSpacesClicked', 'onCollapseSpacesClicked', 'onToggleClicked', 'onLeaveOrganizationClicked', 'onRequestAdminAccessClicked');

      this._super();

      this.model = this.options.model;
      this.isCurrent = this.model.get('id') === this.options.currentOrganization;
      this.isExpanded = _.indexOf(this.options.collapsedOrganizations, this.model.get('id')) <= -1;
      this.expandedSpaces = false;
      this.highlightGrants = false;
      this.spacesRendered = false;
      this.isFromSharefile = config.user.from_sharefile;

      var isOnGrantURL = function() {
        return config.current_grant && config.current_grant.ref.link === window.location.toString().substr(0, config.current_grant.ref.link.length);
      };
      var isOnOrganizationSubdomain = function(model) {
        return (config.orgSlug && model.get('url_label') === config.orgSlug);
      };
      var isOnGrantIndexPage = function() {
        return (config.orgSlug && routes.organization_grants_path(config.orgSlug, {format:'html'}) === window.location.pathname);
      };

      this.highlightGrants = (isOnGrantURL() && isOnOrganizationSubdomain(this.model) && !utils.isUserInSpace(config.space_id)) || (this.isCurrent && isOnGrantIndexPage());

      this.bindEvents();
    },

    bindEvents: function() {

    },

    groups: function() {
      return this.model.spacesByType();
    },

    render: function() {
      var groups = this.groups();

      this.elm.toggleClass('current', this.isCurrent);
      this.elm.toggleClass('expanded', this.isExpanded || this.highlightGrants || this.isCurrent);

      var organizationAttributes = _.extend(_.clone(this.model.attributes), {url: this.model.get('url').substr(0, this.model.get('url').length - 1)});

      var elmOrganization = $(this.getTemplate(jstOrgNavOrganization, {
        data: {
          organization: organizationAttributes
        },
        isCurrent: this.isCurrent,
        nonTopSpaces: _.some(groups.regular, function(space) {
          return !space.get('top') && !space.get('archived');
        }),
        expandedSpaces: this.expandedSpaces,
        canUpdate: this.model.can('update'),
        canAddSpace: this.model.can('add_space'),
        canManageWorkspaces: this.model.isEmployee() || (groups.regular && groups.regular.length > 0),
        canAddContract: this.model.can('add_contract'),
        isUpgradeable: this.model.upgradeable(),
        notUpgraded: this.model.notUpgraded(),
        partiallyUpgraded: this.model.partiallyUpgraded(),
        isEmployee: this.model.isEmployee(),
        isAdmin: this.model.isAdmin(),
        highlightGrants: this.highlightGrants,
        isFromSharefile: this.isFromSharefile,
        isTrialOrg: this.isTrialOrg(),
        isExpiredTrialOrg: this.checkTrialOrganization(),
      }));

      // Don't render spaces etc. if org is collapsed
      if (this.isExpanded || this.highlightGrants || this.isCurrent) {
        this.renderSpaceList(groups, elmOrganization);
      }

      this.elm.html(elmOrganization);
    },

    renderSpaceList: function(groups, elmOrganization) {
      var self = this;
      var domFragment = document.createDocumentFragment();

      // Employee networks
      _.each(groups.emp_network, function(space) {
        domFragment.appendChild($(self.renderSpace(space)).get(0));
      });

      // Item grants
      if (this.model.get('grants_count')) {
        domFragment.appendChild($(self.renderGrants()).get(0));
      }

      // Regular and demo spaces
      _.each(groups.regular, function(space) {
        if ((self.expandedSpaces && !space.get('archived')) || space.get('top') || space.get('id') === config.space_id) {
          domFragment.appendChild($(self.renderSpace(space)).get(0));
        }
      });

      if (elmOrganization.find('.org-spaces').length) {
        elmOrganization.find('.org-spaces').prepend(domFragment);
      }
      domFragment = null;
      this.spacesRendered = true;
    },

    renderGrants: function() {
      var organizationAttributes = _.extend(_.clone(this.model.attributes), {url: this.model.get('url').substr(0, this.model.get('url').length - 1)});
      return this.getTemplate(jstOrgNavGrants, {
        data: {
          organization: organizationAttributes
        },
        highlightGrants: this.highlightGrants,
        grantCount: podioUtils.showFeature('app_share_with_users') ? this.model.get('grants_count') : false
      });
    },

    renderSpace: function(space) {
      var organizationAttributes = _.extend(_.clone(this.model.attributes), {
        url: this.model.get('url').substr(0, this.model.get('url').length - 1)
      });

      return this.getTemplate(jstOrgNavSpace, {
        data: {
          space: space.attributes,
          organization: organizationAttributes
        },
        canUpdate: space.can('update'),
        canShare: space.can('share')
      });
    },

    onExpandSpacesClicked: function() {
      this.expandedSpaces = true;
      this.render();
    },

    onCollapseSpacesClicked: function() {
      this.expandedSpaces = false;
      this.render();
      $.scrollTo(this.elm);
    },

    onToggleClicked: function(elmTarget, e) {
      if (!$(e.target).hasClass('org-spanner') && $(e.target).parents('.action-dropdown-wrapper').length === 0) {
        var self = this;

        // Render spaces if they are not already present
        if (!this.spacesRendered && !this.isExpanded) {
          this.renderSpaceList(this.groups(), this.elm);
        }

        this.elm.find('.body').slideToggle(150, function() {
          self.isExpanded = self.isExpanded ? false : true;
          self.elm.toggleClass('expanded', self.isExpanded);

          if (self.isExpanded) {
            self.options.eventBus.trigger('leftnav:orgExpanded', self.model.get('id'));
          } else {
            self.options.eventBus.trigger('leftnav:orgCollapsed', self.model.get('id'));
          }

        });
      }
    },

    onRequestAdminAccessClicked: function() {
      var orgId = this.model.get('id');

      actionDropdown.hideAll();
      modal.showLoading();

      transport.getJSON(routes.request_admin_access_organization_path(orgId), {}, function(responseData) {
        var ControllerConversationNew = require('controllers/conversations/Podio.Controllers.Conversations.New');
        ControllerConversationNew.showWithPrePopulate({
          userIds: responseData.data.org_admin_user_ids,
          subject: responseData.data.org_admin_request_subject,
          text: responseData.data.org_admin_request_text
        });
      });

    },

    onLeaveOrganizationClicked: function() {
      var orgId = this.model.get('id');
      var self = this;
      transport.getJSON(routes.contract_exists_for_org_path({org_id: orgId}), {}, function(responseData) {
        var body;

        if (responseData.data.has_contract) {
          var modalTitle = t('Leave organization #leave_org_modal');
          var modalHeader = t('You cannot leave this organization yet. #leave_org_modal');
          var conversationButton = '';
          body = '<p>' + t('You own a contract on this organization and therefore cannot leave without downgrading or transferring the contract to someone else. #leave_org_modal') + '<p>';
          body += '<p>' + t('Please get in touch with you Podio Support to get help transferring your contract. #leave_org_modal') + '</p>';
          body = "<div class='image-block'><div class='img'><div class='pads-logo'></div></div><div class='bd'><h4 class='modal-delete-confirm-title'>" + modalHeader + "</h4><div class='modal-delete-confirm-body'>" + body + "</div><div class='modal-delete-confirm-buttons buttons'>" + conversationButton + "<a href='' class='button-new secondary close-button'>" + t('Cancel #leave_org_modal') + '</a></div></div></div>';

          modal.show(body, {'title' : modalTitle, height: 140, width: 560});
        }
        else {
          body = '<p>' + t('You will <b>only</b> be able to join this organization again if you are invited back in. If you are the <b>last</b> person in this organization <b>all</b> the spaces, apps and items in this organization will be deleted <b>permanently</b>. #org_page') + '</p>';
          modal.showDeleteConfirm(t('Leave Organization #org_page'), t('Are you sure you want to leave the organization: "{0}"? #org_page').format(self.model.get('name')), { variant: 'leave', body: body }, function() {
            transport.deleteJSON(routes.leave_organization_path(orgId));
          });
        }

      });

    },

    onCancelTrialOrgClick: function() {
      var orgId = this.model.get('id');

      body = '<p>' + t('You are canceling your <b>trial membership</b>. The organization will be deleted <b>permanently</b>. #org_page') + '</p>';
      modal.showDeleteConfirm(t('Cancel trial Organization #org_page'), t('Are you sure you want to cancel the trial organization: "{0}"? #org_page').format(this.model.get('name')), { variant: 'cancelTrialOrg', body: body }, function() {
        transport.deleteJSON(routes.cancel_trial_organization_path(orgId));
      });
    },

    onPublishSpaceClicked: function(elmTarget, e) {
      var spaceId = elmTarget.data('id');
      shareSpaceModal.show(spaceId);
    },

    onEditOrganizationClicked: function() {
      organizationsSetup.showSetupModal(this.model.get('id'));
    },

    onDeleteInactiveOrgClicked: function(elmTarget, e) {
      var orgId = this.model.get('id');
      var domain = this.model.get('first_domain');

      e.preventDefault();
      e.stopPropagation();

      var containerNode = document.body.appendChild(document.createElement('div'));

      this.deleteInactiveOrgModal = ReactDOM.render(DeleteInactiveOrganizationModalComponent({
        domain: domain,
        onDelete: function() {
          transport.deleteJSON(routes.leave_organization_path(orgId));
        },
        onClose: function() {
          ReactDOM.unmountComponentAtNode(containerNode);
          containerNode.parentNode.removeChild(containerNode);
        }
      }), containerNode);
    },

    onActionDropdownOpened: function(elmTarget, e) {
      var documentHeight = $(window).height();
      var offsetTop = elmTarget.offset().top;
      if (documentHeight - offsetTop + elmTarget.height() < 400) {
        elmTarget.addClass('bottom-fix');
      }
    },

    onActionDropdownClosed: function(elmTarget) {
      elmTarget.removeClass('bottom-fix');
    },

    onPotentialPaywallClick: function(elmTarget, e) {
      if (this.model.get('tier') !== null) {
        return false;
      }

      var feature = elmTarget.get(0).classList[1];
      if (feature === 'user_management' && this.model.get('type') === 'trial') {
        return false;
      }

      e.preventDefault();

      var node = document.querySelector('.notifications-dropdown');

      if (!_.isElement(node)) {
        node = document.createElement('div');
        node.className = 'notifications-dropdown';

        document.body.appendChild(node);
      }

      this.paywallComponent = ReactDOM.render(PricingPaywallComponent({
        isOpen: true,
        closeOnBackdropClick: false,
        hideOnEsc: false,
        feature: feature,
        organization: this.model.attributes
      }), node);

      this.paywallComponent.open();
    },

    onCreateSpaceClick: function() {
      globalEvent.trigger('spaceswitcher:hide');
    },

    isTrialOrg: function() {
      return this.model.attributes.type === 'trial'
    },

    checkTrialOrganization: function() {
      if (this.isTrialOrg() && this.model.attributes.trial_expired_on) {
        return moment(this.model.attributes.trial_expired_on).isBefore();
      }
      return false;
    }
  });
});

